import {
  PRICE_RANGE_FILTER_CURRENCY_SUFFIX,
  PRICE_RANGE_FILTER_MAX_PRICE_PLACEHOLDER,
  PRICE_RANGE_FILTER_MIN_PRICE_PLACEHOLDER, PRICE_RANGE_FILTER_NAME_DELIMITER,
  PRICE_RANGE_FILTER_VALUE_DELIMITER
} from './filterConstants';

const generateCustomPriceRangeFilterNameFromValuePartials = (minPrice, maxPrice) => {
  let result = '';

  if (minPrice) {
    result += minPrice.toString();

    if (!maxPrice) {
      result += PRICE_RANGE_FILTER_CURRENCY_SUFFIX;
    }
  } else {
    result += PRICE_RANGE_FILTER_MIN_PRICE_PLACEHOLDER;
  }

  result += PRICE_RANGE_FILTER_NAME_DELIMITER;

  if (maxPrice) {
    result += maxPrice.toString() + PRICE_RANGE_FILTER_CURRENCY_SUFFIX;
  } else {
    result += PRICE_RANGE_FILTER_MAX_PRICE_PLACEHOLDER;
  }

  return result;
}

const generateCustomPriceRangeFilterName = (priceRange) => {
  return generateCustomPriceRangeFilterNameFromValuePartials(
    priceRange.minPrice,
    priceRange.maxPrice,
  )
}

const generateCustomPriceRangeFilterValue = (priceRange) => {
  let result = '';

  if (priceRange.minPrice) {
    result += priceRange.minPrice;
  } else {
    result += PRICE_RANGE_FILTER_MIN_PRICE_PLACEHOLDER;
  }

  result += PRICE_RANGE_FILTER_VALUE_DELIMITER;

  if (priceRange.maxPrice) {
    result += priceRange.maxPrice;
  } else {
    result += PRICE_RANGE_FILTER_MAX_PRICE_PLACEHOLDER;
  }

  return result;
}

export {
  generateCustomPriceRangeFilterName,
  generateCustomPriceRangeFilterValue,
}
